export class FileUploadConfig {
    API: string;
    fileTypes: any;
    maxFileSize: string;
    fileTypeMsg: string;
    filesizeMsg: string;
    uploadSuccessMsg: string;
    uploadFailureMsg: string;
    removePlaceHolder: string;
    uploadBtnLabel: string;
}